import { ErrorMessage, Field, Form, Formik } from "formik";
import { Alert, Button } from "react-bootstrap";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FiCheck } from "react-icons/fi";
import materialTypeServices from "../../../../redux/services/materialTypeServices";

const MaterialTypeForm = ({ fetchMaterialTypes }) => {
  const [error, setError] = useState(null);
  const [mTypes, setMTypes] = useState([]);
  const navigate = useNavigate();
  const formikRef = useRef();
  const { id } = useParams();

  useEffect(() => {
    async function fetchMaterialTypeDetails() {
      let response = await materialTypeServices.show(id);

      if (response.status) {
        if (formikRef.current) {
          formikRef.current.setFieldValue("name", response.data.name);
          formikRef.current.setFieldValue(
            "material_type_id",
            response.data.material_type_id
          );
        }
      }
    }

    async function fetchParents() {
      let response = await materialTypeServices.view();

      if (response.status) {
        setMTypes(response.data);
      }
    }

    fetchParents();

    if (id) {
      fetchMaterialTypeDetails();
    }
  }, [id]);

  return (
    <div className="bg-white shadow-sm p-3 rounded">
      <h4 className="text-primary pb-2 border-bottom mb-3">
        Add New Material Type
      </h4>
      {error ? <Alert variant="danger">{error}</Alert> : null}

      <Formik
        initialValues={{
          name: "",
          material_type_id: null,
        }}
        innerRef={formikRef}
        validate={(values) => {
          const errors = {};
          if (!values?.name) errors.name = "Please enter name.";

          return errors;
        }}
        onSubmit={async (values, { setSubmitting, setValues }) => {
          let response = !id
            ? await materialTypeServices.store(values)
            : await materialTypeServices.update(id, values);
          setSubmitting(false);

          if (response.status) {
            id ? navigate("/admin/material-type") : fetchMaterialTypes();

            if (!id) {
              setValues({
                name: "",
                material_type_id: null,
              });
            }
          } else {
            if (response?.data?.data?.message)
              setError(response?.data?.data?.message);
            else if (response?.error?.message)
              setError(response?.error?.message);
          }
        }}
      >
        {({ values, isSubmitting, handleBlur, handleChange }) => (
          <Form>
            <div className="mb-3">
              <select
                type="text"
                className="form-select"
                name="material_type_id"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.material_type_id}
              >
                <option value>ROOT </option>
                {mTypes.map((mType, index) => (
                  <option value={mType.id} key={index}>
                    {mType.name}
                  </option>
                ))}
              </select>
              <ErrorMessage
                name="material_type_id"
                component="div"
                className="text-danger"
                id="material_type_id"
              />
            </div>

            <div className="mb-3">
              <Field
                type="text"
                placeholder="Name"
                className="form-control"
                name="name"
              />
              <ErrorMessage
                name="name"
                component="div"
                className="text-danger"
                id="name"
              />
            </div>

            <div className={!id ? "d-grid" : null}>
              <Button type="submit" variant="primary" disabled={isSubmitting}>
                {isSubmitting ? (
                  "Wait..."
                ) : (
                  <>
                    <FiCheck /> {id ? "Update" : "Create"}
                  </>
                )}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default MaterialTypeForm;
